import { ReactNode } from 'react';
import classNames from 'classnames';
import { downloadPrivateFile, viewPrivateFile } from '@/shared/lib/utils/privateFiles';
import type { FileInfo } from '@/shared/types/files';

interface PrivateFileLinkProps {
  file: FileInfo;
  /** view — открыть во вкладке, download — сохранить файлом */
  action?: 'view' | 'download';
  className?: string;
  children?: ReactNode;
}

/**
 * Ссылка на приватный файл: ссылка на него живёт минуты, поэтому запрашивается по клику,
 * а не лежит в href. Оформление — целиком из className/children места использования.
 */
export const PrivateFileLink = ({
  file,
  action = 'view',
  className,
  children,
}: PrivateFileLinkProps) => (
  <button
    type="button"
    title={file.name}
    className={classNames('cursor-pointer text-left', className)}
    onClick={() => (action === 'download' ? downloadPrivateFile(file) : viewPrivateFile(file))}
  >
    {children ?? file.name}
  </button>
);
